export const PRODUCT_NAME = 'RemoteXpert';

export const SENTRY_DNS_URL = 'https://97dcdd8ca8924e74924e26279572b7cb@sentry.io/1234097';

export const APPLE_APP_STORE_URL = 'https://itunes.apple.com/de/app/remotexpert-get-help-faster/id1416497894';

export const PRIVACY_NOTICE_LABEL = "Privacy Notice";
export const PRIVACY_NOTICE_URL = "/legal/privacy_notice_en.html";
